module.exports = __webpack_public_path__ + "static/img/10.dfdc813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/10.png
// module id = 460W
// module chunks = 1